import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { ActivityKind } from '../../../../entities/shared/activity.type';
import { MetadataAttachment } from '../../../../entities/shared/attachment';

@MergeSchema({
    entity: ActivityEntityName.Activity,
    name: 'ActivityMergeSchema',
})
export class ActivityMergeData {
    @MergeField()
    note: string;

    @MergeField()
    createdBy: string;

    @MergeField()
    createdDate: string;

    // @MergeField()
    // attachments: AttachmentMergeData[];

    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    attachments: AttachmentMergeData[] = [];

    kind: ActivityKind;
}

export const ActivityMergeSchema = getSchema(ActivityMergeData);

@MergeSchema({
    entity: ActivityEntityName.Attachment,
    name: 'AttachmentMergeSchema',
})
export class AttachmentMergeData {
    @MergeField()
    title: string;

    @MergeField()
    path: string;

    @MergeField()
    thumbnail: string;

    @MergeField()
    type: string;

    @MergeField({
        hidden: true
    })
    data: string;

    @MergeField()
    shared?: string;

    @MergeField()
    tags?: string;
}

export const AttachmentMergeSchema = getSchema(AttachmentMergeData);

@MergeSchema({
    entity: ActivityEntityName.Attachment,
    name: 'AttachmentsMergeSchema',
})
export class AttachmentsMergeData {
    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail']
    })
    attachments: AttachmentMergeData[] = [];
}

export const AttachmentsMergeSchema = getSchema(AttachmentsMergeData);

export const transformAAttachmentToMergeData = (f: MetadataAttachment): AttachmentMergeData => {
    return {
        title: f.title,
        path: f.path,
        thumbnail: f.thumbnail,
        type: f.type,
        shared: f?.effectiveSharing?.shared?.map(s => s).join('; '),
        tags: f.tags?.map(t => t.name).join('; ')
    } as AttachmentMergeData;
}